import DiscoverServiceProviderMeetingRequest from './DiscoverServiceProviderMeetingRequest'

export default DiscoverServiceProviderMeetingRequest
